import { makeMockFormatedFieldDropDown } from "../../utils/formatFields";
import { CustomChip } from "./CustomChip";

export const SingleValueCustomChip = ({text}:{text:string}) => {
	const mockFormatedField = makeMockFormatedFieldDropDown([{ text: text, value: text }]);
	return (
		<CustomChip field={mockFormatedField} label={text} />
	);
};